// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__fJkTG","content":"LoadingAlert_content__2cBaL"};